export default __webpack_public_path__ + "static/img_4-59b2e063cd14d4aafcc28679416b9e8c.png";